// extracted by mini-css-extract-plugin
export default {"facetMenu":"Ax-z","fixed":"Bx-z","nonLayerdFacets":"Cx-z","productCount":"Dx-z","facetBack":"Ex-z","arrow":"Fx-z","facetClose":"Gx-z"};